import { render, staticRenderFns } from "./TrumboEditor.vue?vue&type=template&id=c3c9dd6e"
import script from "./TrumboEditor.vue?vue&type=script&lang=js"
export * from "./TrumboEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports